import { GetFullUserType, PutUserType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useUpdateMe = () => {
	const queryClient = useQueryClient()

	return useMutation<GetFullUserType, unknown, PutUserType>({
		mutationFn: async (data: PutUserType) => {
			const response = await api.patch<GetFullUserType>('/users', data)
			return response.data
		},
		onSuccess: (data) => {
			queryClient.setQueryData(queryKeys.me(), data)
		},
	})
}

